export enum NetworkType {

    XHR
}
